import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  top: 1rem;
  right: ${({ error }) =>
    error ? "calc(0.375em + 2.5rem)" : "calc(0.375em + 0.325rem)"};
  cursor: pointer;
`;
